<template>
  <div>
    <el-form size="small" class="d2-mt-20" :inline="false" :model="searchForm" ref="searchForm" @submit.native.prevent
      v-if="checked.search">
      <el-input placeholder="请输入关键字搜索" v-model="searchForm.keyWords" class="input-with-select" style="width: 400px"
        @keyup.enter.native="handleSearchFormSubmit(searchForm.keyWords)">
        <el-button slot="append" icon="el-icon-search" @click="handleSearchFormSubmit(searchForm.keyWords)"></el-button>
      </el-input>
    </el-form>
    <el-form size="small" class="d2-mt-20" :inline="false" :model="searchForm" ref="searchForm" @submit.native.prevent
      v-else-if="checked.filterYear">
      <el-date-picker v-model="searchForm.searchYear" type="year" placeholder="选择年" format="yyyy" value-format="yyyy"
        @change="handleSearchYearSubmit">
      </el-date-picker>
      <el-button type="primary" icon="el-icon-search" class="d2-ml-15"
        @click="handleSearchYearSubmit(searchForm.searchYear)">搜索</el-button>
    </el-form>

    <template v-if="checked.tabs">
      <el-tabs v-model="checked.active" @tab-click="handleClick">
        <el-tab-pane v-for="(item, index) in checked.tab" :key="index" :label="item.name" :name="item.active">
          <div class="sec_main d2-mt-10">
            <div class="sec_con sec_con2" v-for="(n, i) in ListData" :key="i" @click="listDetialHandle(n)">
              <img class="sec_con_img" :src="n.FaceImage" />
              <div class="sec_intro">
                <p class="sec_intro_title">
                  {{ n.ActivityName }}
                  <span class="sec_intro_date">{{ n.PublishDate }}</span>
                </p>
                <span class="sec_intro_line"></span>
              </div>
              <template v-if="n.IsSignUp == 0">
                <img class="sec_con_icon" src="@/assets/img/activeAlternate.png" />
              </template>
              <template v-else-if="n.IsSignUp == 1">
                <img class="sec_con_icon" src="@/assets/img/activeSuccess.png" />
              </template>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-else>
      <div class="sec_main d2-mt-20" v-loading="loading" element-loading-text="加载中...">
        <template v-if="ListData.length!=0">
          <div class="sec_con sec_con2" v-for="(n, i) in ListData" :key="i" @click="listDetialHandle1(n)">
            <el-image class="sec_con_img" :src="n.FmImgUrl || n.FaceImage || n.MessageContent || n.CoverImg"
              :style="{height:n.MessageContent?'240px':''}" fit="cover" :preview-src-list="n.srcList"></el-image>
            <div class="sec_intro">
              <p class="sec_intro_title">
                {{ n.Title || n._SUBJECT || n.MessageTitle }}
                <span
                  class="sec_intro_date">{{ n.ReleaseTime || n.PublishDate || n.CreationTime || n.CreateTime }}</span>
              </p>
              <span class="sec_intro_line"></span>
            </div>
          </div>
        </template>
        <el-empty class="auto" v-else></el-empty>
      </div>
    </template>
  </div>
</template>

<script>
  import _ from "lodash";
  import dayjs from "dayjs";
  import * as indexService from "@/api/sys/index";
  export default {
    name: "listActive",
    data() {
      return {
        searchForm: {
          keyWords: "",
          searchYear: dayjs().format("YYYY"),
        },
        activeName: "0",
      };
    },
    props: {
      code: {
        type: String,
        required: false,
        default: "",
      },
      checked: {
        type: Object,
        required: false,
        default: {},
      },
      ListData: {
        type: Array,
        required: false,
        default: () => [],
      },
      readData: {
        type: Array,
        required: false,
        default: () => [],
      },
      total: {
        type: Number,
        required: false,
        default: 0,
      },
      loading: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    created() {},
    mounted() {},
    methods: {
      handleSearchFormSubmit: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.$emit("search", this.pageIndex, search);
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      handleSearchYearSubmit: _.debounce(
        function (search) {
          this.pageIndex = 0;
          this.$emit("searchyear", this.pageIndex, search);
        },
        1000, {
          leading: true,
          trailing: false,
        }
      ),
      handleClick(tab, event) {
        this.pageIndex = 0;
        this.$emit("message", this.pageIndex);
      },
      listDetialHandle(item) {
        console.log(item);
        this.$router.push({
          path: "webView",
          query: {
            code: "activity",
            shortTitle: item.Type,
            detailed: false,
            dataId: item.ID,
            fiter: "",
            name:this.checked.name
          },
        });
      },
      listDetialHandle1(item) {
        if (this.checked.name == '我的活动') {
          this.$router.push({
            path: "webView",
            query: {
              code: "activity",
              dataId: item.ID,
              limit: 10000,
              orderby: "SortIndex",
              start: 1,
              name:this.checked.name
            },
          });
        } else if (this.checked.name == '我的电子卡') {

        } else if (this.checked.name == '工会发布列表') {
          this.$router.push({
            path: "webView",
            query: {
              code: "comment",
              shortTitle: "工会职代会热点",
              detailed: false,
              dataId: item.ID,
              fiter: "",
            },
          });
        } else if (item.hasOwnProperty('Type') && item.Type!=null) {
          this.$router.push({
            path: "webView",
            query: {
              code: "comment",
              shortTitle: item.Type,
              detailed: false,
              dataId: item.ID,
              fiter: "",
            },
          });
        } else {
          this.$router.push({
            path: "webView",
            query: {
              code: "comment",
              shortTitle: "活动分享发布",
              detailed: false,
              dataId: item.ID,
              fiter: "",
            },
          });
        }

      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "~@/assets/style/style.css";
  @import "~@/assets/style/richText.scss";
</style>